import { Truck, Users, Clock, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@flote/ui';
import { deliveryTsr } from '../api';

function StatCard({
  title,
  value,
  icon: Icon,
  description,
}: {
  title: string;
  value: string | number;
  icon: React.ComponentType<{ className?: string }>;
  description?: string;
}) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        <Icon className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{value}</div>
        {description && (
          <p className="text-xs text-muted-foreground">{description}</p>
        )}
      </CardContent>
    </Card>
  );
}

export function DashboardPage() {
  const { data: statsResponse, isLoading } = deliveryTsr.adminDashboard.getStats.useQuery({
    queryKey: ['dashboard-stats'],
  });

  const stats = statsResponse?.status === 200 ? statsResponse.body : null;

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Dashboard</h2>
        <p className="text-muted-foreground">Overview of your delivery operations</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <StatCard
          title="Total Deliveries"
          value={stats?.totalTasks ?? 0}
          icon={Truck}
          description="All time"
        />
        <StatCard
          title="Active Drivers"
          value={stats?.activeDrivers ?? 0}
          icon={Users}
          description="Currently on duty"
        />
        <StatCard
          title="In Progress"
          value={stats?.inTransitTasks ?? 0}
          icon={Clock}
          description="Being delivered"
        />
        <StatCard
          title="Completed Today"
          value={stats?.completedToday ?? 0}
          icon={CheckCircle}
          description="Successfully delivered"
        />
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>Tasks by Status</CardTitle>
          </CardHeader>
          {/* <CardContent>
            <div className="space-y-2">
              {stats?.tasksByStatus?.map((item) => (
                <div key={item.status} className="flex items-center justify-between">
                  <span className="capitalize">{item.status.replace('_', ' ')}</span>
                  <span className="font-medium">{item.count}</span>
                </div>
              )) ?? (
                <p className="text-sm text-muted-foreground">No data available</p>
              )}
            </div>
          </CardContent> */}
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Recent Activity</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Activity feed will be implemented in a future update.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
